<nz-result nzStatus="500" nzTitle="500" nzSubTitle="Sorry, there is an error on server." *ngIf="applicationError">
  <div nz-result-content>
    <div class="desc">
      <span nz-paragraph *ngFor="let parent of (this.applicationErrorDetails | keyvalue)">
        <strong>{{ parent.key }}:</strong> {{parent.value | json}}
        <br />
      </span>
    </div>
  </div>
  <div nz-result-extra>
    <button nz-button nzType="primary" (click)="refresh()">
      <i class="fas fa-sync"></i> &nbsp; Refresh
    </button>
  </div>
</nz-result>
<div class="main-container root {{screenSize}}" *ngIf="!applicationError">
  <div style="width: 100%">
    <router-outlet></router-outlet>
  </div>
</div>
